import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
// -------------------------------------------------------

class FollowerTrends extends React.Component {
  /*
   * 初回データ取得
   */
  getFollowersPer(list, month, fst_score) {
    let temp = list.concat().reverse();
    
    let first_score = fst_score;
    
    let min = null;
    let max = null;
    let last_score = null;
    temp.map((d, key) => {
      let diff = Moment().diff( Moment(d.set_date, 'YYYY/MM/DD'), 'month');
      if( diff < month ){
        if( min == null || min > d.followers ) min = d.followers;
        if( max == null || max < d.followers ) max = d.followers;
        
        if( first_score == null && fst_score == null ) first_score = d.followers;
        last_score = d.followers;
      }
    });
    
    if( min == null ) min = 0;
    if( max == null ) max = 0;
    
    let diff_followers = (first_score - last_score);
    
    let percent = (first_score / last_score);
    if( isNaN(percent) || percent == 'Infinity' ) percent = 1;
    
    return {
      followers  : diff_followers,
      last_score : last_score,
      percent    : percent,
    }
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    if( this.props.ng_html != null ) return this.props.ng_html;
    if( data.follower_history == null ) return null;

    // フォロワー推移の作成
    let follower_history = [];
    data.follower_history.map((d, key) => {
      if( key > 0 ){
        let old = data.follower_history[(key - 1)];

        // 空白期間の穴埋め
        let diff = Moment(d.date).diff( Moment(old.date), 'days');
        if( diff > 1 ){
          for( let i = 1; i < diff; i++ ){
            let grade = (d.followers - old.followers);

            let his_date = Moment(old.date).add(i, 'days').format('M/D');
            let set_date = Moment(old.date).add(i, 'days').format('YYYY/MM/DD');
            follower_history.push({ date: his_date, set_date: set_date, followers: Math.round(old.followers + ((grade / diff) * i)) });
          }
        }
      }

      follower_history.push({ date: Moment(d.date).format('M/D'), set_date: Moment(d.date).format('YYYY/MM/DD'), followers: d.followers });
    });
    
    // 過去比率の設定
    let month_1 = this.getFollowersPer.bind(this)(follower_history, 1, null);
    let month_3 = this.getFollowersPer.bind(this)(follower_history, 3, month_1.last_score);
    let month_6 = this.getFollowersPer.bind(this)(follower_history, 6, month_3.last_score);
    
    let targets = [
      { id: 'month_6', name: '3ヶ月～6ヶ月の変化', score: month_6 },
      { id: 'month_3', name: '1ヶ月～3ヶ月の変化', score: month_3 },
      { id: 'month_1', name: '現在～1ヶ月の変化',  score: month_1 },
    ];
    
    return (
      <div className="influencer-follower-trends">
        
        <h3><b>フォロワー数推移</b></h3>
        <h5><p>取得できている全期間の推移が表示されます</p></h5>
        
        <ul className="follower-score">
          { targets.map((d, key) => {
            let per_diff = ((d.score.percent - 1) * 100);
            
            return (
              <li key={key}>
                <h3>{d.name}</h3>
                { (per_diff < 0)
                  ? <h4 className="minus">{per_diff.toFixed(1)}%</h4>
                  : <h4 className="plus">+{per_diff.toFixed(1)}%</h4>
                }
                { (d.score.followers < 0)
                  ? <h5 className="minus">({Utils.viewInt(d.score.followers)}人)</h5>
                  : <h5 className="plus">(+{Utils.viewInt(d.score.followers)}人)</h5>
                }
              </li>
            );
          })}
        </ul>
        
        <LineChart width={770} height={250} data={follower_history} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis domain={['dataMin', 'dataMax']} />
          <Tooltip />
          <Line type="monotone" dataKey="followers" name="フォロワー数" stroke="#2196f3" fill="#4d4054" dot={false} />
        </LineChart>
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default FollowerTrends;